import { AlertTriangle, CreditCard } from 'lucide-react';
import { GlassCard } from '@/components/ui/glass-card';
import { Button } from '@/components/ui/button';

export function SubscriptionBlockedPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <GlassCard className="w-full max-w-lg p-8 text-center">
        <div className="mb-6 flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
            <AlertTriangle className="h-8 w-8 text-destructive" />
          </div>
        </div>

        <h1 className="mb-2 text-2xl font-bold text-foreground">Assinatura Vencida</h1>
        <p className="mb-6 text-muted-foreground">
          Sua assinatura expirou e o período de carência foi ultrapassado.
          Para continuar utilizando o sistema, é necessário renovar seu plano.
        </p>

        <div className="mb-6 rounded-lg border border-border bg-muted/30 p-4">
          <h3 className="mb-2 text-sm font-medium text-foreground">O que acontece agora?</h3>
          <ul className="space-y-2 text-left text-sm text-muted-foreground">
            <li className="flex items-start gap-2">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-destructive" />
              O acesso ao sistema está temporariamente bloqueado
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-warning" />
              Seus dados estão seguros e serão mantidos
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-success" />
              Ao renovar, o acesso será restaurado imediatamente
            </li>
          </ul>
        </div>

        <div className="flex flex-col gap-3">
          <Button className="w-full">
            <CreditCard className="mr-2 h-4 w-4" />
            Renovar Assinatura
          </Button>
          <Button variant="outline" className="w-full" onClick={() => {
            localStorage.clear();
            window.location.href = '/login';
          }}>
            Sair
          </Button>
        </div>

        <p className="mt-6 text-xs text-muted-foreground">
          Precisa de ajuda? Entre em contato com o suporte pelo WhatsApp ou email.
        </p>
      </GlassCard>
    </div>
  );
}
